<ng-container [ngSwitch]="filterMode">
  <!-- Dropdown with only one selection -->
  <p-multiSelect
    *ngSwitchCase="allFilterModes.AUTOCOMPLETE_SINGLE"
    #scipFilter
    class="avano-combobox-style avano-combobox-style-oneline"
    panelStyleClass="avano-combobox-overlay avano-scrollbars avano-combobox-style-singleselect"
    styleClass="avano-multiselect-scrollbar"
    appendTo="body"
    [options]="filterValuesSuggestions"
    [(ngModel)]="currentUserInput"
    [optionLabel]="'label'"
    [optionValue]="'value'"
    [showToggleAll]="false"
    (onChange)="broadcastUserInput($event); scipFilter.hide()"
    [showHeader]="false"
    [emptyFilterMessage]="translationKeys.commonTranslationKey.filter.noResults | translate"
  >
    <ng-template pTemplate="selectedItems">
      <div *ngIf="currentUserInput?.length" class="avano-combobox-style-singleselect-selected-items">
        <span *ngIf="singleSelectLabelField" avanoEllipsis [useNoWrap]="false" scipSpacesAsIs>
          {{ singleSelectLabelField }}
        </span>
        <span *ngIf="!singleSelectLabelField && !valuesLabelField" avanoEllipsis [useNoWrap]="false" scipSpacesAsIs> {{ currentUserInput[0] }}</span>
        <span *ngIf="!singleSelectLabelField && valuesLabelField" avanoEllipsis [useNoWrap]="false" scipSpacesAsIs>
          {{ currentUserInput[0][valuesLabelField] }}</span
        >
        <span class="avano-combobox-clear" (click)="clearUserInput(); scipFilter.hide(); $event.stopPropagation()">
          <i class="icon-content-cancel"></i>
        </span>
      </div>
    </ng-template>
    <ng-template let-singleSuggestion pTemplate="item">
      <span avanoEllipsis [useNoWrap]="false" scipSpacesAsIs>
        {{ singleSuggestion.label }}
      </span>
    </ng-template>
  </p-multiSelect>

  <!-- Dropdown with multiple selection and search within -->
  <p-multiSelect
    *ngSwitchCase="allFilterModes.AUTOCOMPLETE_MULTIPLE"
    #scipFilter
    [(ngModel)]="currentUserInput"
    [options]="filterValuesSuggestions"
    [optionLabel]="'label'"
    [optionValue]="'value'"
    [placeholder]=""
    [maxSelectedLabels]="10"
    class="avano-combobox-style avano-combobox-style-oneline"
    [panelStyleClass]="'avano-combobox-overlay avano-scrollbars'"
    [styleClass]="'avano-multiselect-scrollbar'"
    [appendTo]="'body'"
    [showToggleAll]="false"
    (onChange)="broadcastUserInput()"
    [emptyFilterMessage]="translationKeys.commonTranslationKey.filter.noResults | translate"
    [resetFilterOnHide]="true"
  >
    <ng-template pTemplate="selectedItems">
      <div *ngIf="currentUserInput?.length" class="avano-combobox-style-singleselect-selected-items">
        <span avanoEllipsis>{{ currentUserInput.length }} {{ translationKeys.scipTable.filter.combobox.selectedLabel | translate }}</span>
        <span class="avano-combobox-clear" (click)="clearUserInput(); $event.stopPropagation()">
          <i class="icon-content-cancel"></i>
        </span>
      </div>
    </ng-template>
    <ng-template let-singleSuggestion pTemplate="item">
      <span avanoEllipsis [useNoWrap]="false" scipSpacesAsIs>
        {{ singleSuggestion.label }}
      </span>
    </ng-template>
  </p-multiSelect>

  <!-- Datepicker (only one date) -->
  <p-calendar
    *ngSwitchCase="allFilterModes.DATEPICKER_SINGLE"
    #scipFilter
    [showIcon]="true"
    appendTo="body"
    class="scip-calendar-input"
    panelStyleClass="scip-table-filter-calendar-overlay"
    todayButtonStyleClass="calendar-today-button"
    [showButtonBar]="true"
    (onSelect)="broadcastUserInput()"
    (onClearClick)="clearUserInput()"
    [(ngModel)]="currentUserInput"
    [readonlyInput]="true"
    [maxDate]="todayDate"
  ></p-calendar>

  <!-- Plain input text (also default case) -->
  <input *ngSwitchDefault avanoInputText type="text" (input)="throttleUserInput()" (keydown.enter)="$event.stopPropagation()" [(ngModel)]="currentUserInput" />
</ng-container>
